
import React, { Component } from 'react';
import AKACollectLoader from './include/Common';

class Footer extends Component {
 
  render() {
    return (
      <>
        <AKACollectLoader />
        <footer className="footer">
          <div className="container">
            <ul className="policy">
              <li><a href="https://www.asiae.co.kr/company/policy/service/" target="_blank"> 이용약관 </a></li>
              <li>
                <a href="https://www.asiae.co.kr/company/policy/privacy/" target="_blank">
                  <b>개인정보처리방침</b>
                </a>
              </li>
            </ul>
            <></>
            <div className="footer-txt">
              <p>대표: 마영민, 장범식 </p>
              <p>주소: 서울특별시 중구 충무로 29 아시아미디어타워 10-11층</p>
              <p>
                <span>Tel. <a href="tel:0222002114">02) 2200&#8203;-&#8203;2114</a></span>
                <span>Fax. 02) 2200&#8203;-&#8203;2115</span>
              </p>
            </div>
            <p class="cc"> ※ 일부 용어는 <a href="https://www.econedu.go.kr/" title="새창열기" target="_blank">경제배움e</a>에서 제공한 공공누리 제3유형 콘텐츠를 바탕으로 제작되었습니다. </p>
            <p className="copyright">ⓒ 아시아경제 All rights reserved.</p>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;

